var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWalletColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "190px",
    height: "150px",
    viewBox: "0 0 190 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustration / Wallet") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 190,
    height: 150
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1.05104327e-07%",
    y1: "20.275082%",
    x2: "99.999575%",
    y2: "26.1034973%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "14.0625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8786C9",
    offset: "53.6458313%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5771B8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-19.2%",
    y: "-23.3%",
    width: "138.4%",
    height: "146.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.0391058%",
    y1: "48.8033546%",
    x2: "93.8547498%",
    y2: "50.7977659%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25EBA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F5EBF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.84848571%",
    y1: "49.4736888%",
    x2: "96.9696952%",
    y2: "49.4736878%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#918ABD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878ED1",
    offset: "56.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF81C4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.9196105,85.2035065 C16.2464695,81.7774124 16.2464581,76.2226105 21.9195995,72.7965164 L84.1684723,35.2034998 C89.8416138,31.7774057 99.0395894,31.7774079 104.71273,35.2035019 L150.721924,62.9891396 C156.395065,66.4152336 156.395081,71.9700356 150.721939,75.3961296 L88.4730682,112.989147 C82.7999268,116.415241 73.6019473,116.415241 67.9288063,112.989147 L21.9196105,85.2035065 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.1%",
    y: "-1.8%",
    width: "102.2%",
    height: "103.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-8"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.9254298,82.2035065 C16.2522888,78.7774124 16.2522774,73.2226105 21.9254189,69.7965164 L84.1742916,32.2034998 C89.8474331,28.7774057 99.0454087,28.7774079 104.71855,32.2035019 L150.727743,59.9891396 C156.400884,63.4152336 156.4009,68.9700356 150.727758,72.3961296 L88.4788876,109.989147 C82.8057461,113.415241 73.6077666,113.415241 67.9346256,109.989147 L21.9254298,82.2035065 Z",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.1%",
    y: "-1.8%",
    width: "102.2%",
    height: "103.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-10"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.9254298,79.2035065 C16.2522888,75.7774124 16.2522774,70.2226105 21.9254189,66.7965164 L84.1742916,29.2034998 C89.8474331,25.7774057 99.0454087,25.7774079 104.71855,29.2035019 L150.727743,56.9891396 C156.400884,60.4152336 156.4009,65.9700356 150.727758,69.3961296 L88.4788876,106.989147 C82.8057461,110.415241 73.6077666,110.415241 67.9346256,106.989147 L21.9254298,79.2035065 Z",
    id: "path-11"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.1%",
    y: "-1.8%",
    width: "102.2%",
    height: "103.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-12"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.9254298,76.2034969 C16.2522888,72.7774029 16.2522774,67.2226009 21.9254189,63.7965069 L84.1742916,26.2034903 C89.8474331,22.7773962 99.0454087,22.7773983 104.71855,26.2034924 L150.727743,53.98913 C156.400884,57.4152241 156.4009,62.970026 150.727758,66.3961201 L88.4788876,103.989138 C82.8057461,107.415232 73.6077666,107.415232 67.9346256,103.989138 L21.9254298,76.2034969 Z",
    id: "path-13"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.1%",
    y: "-1.8%",
    width: "102.2%",
    height: "103.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-14"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.9254298,74.01087 C16.2522888,70.5847759 16.2522774,65.029974 21.9254189,61.6038799 L84.1742916,24.0108633 C89.8474331,20.5847692 99.0454087,20.5847714 104.71855,24.0108654 L150.727743,51.7965031 C156.400884,55.2225971 156.4009,60.7773991 150.727758,64.2034931 L88.4788876,101.796511 C82.8057461,105.222605 73.6077666,105.222605 67.9346256,101.796511 L21.9254298,74.01087 Z",
    id: "path-15"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.1%",
    y: "-1.8%",
    width: "102.2%",
    height: "103.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-16"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1.05104327e-07%",
    y1: "37.714886%",
    x2: "99.999575%",
    y2: "40.123732%",
    id: "linearGradient-17"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "14.0625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8786C9",
    offset: "53.6458313%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5771B8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M156.121766,70.8500061 C156.048504,71.819563 155.744748,72.7555794 155.237302,73.5753174 C154.729855,74.3950554 154.034347,75.07328 153.212303,75.5500183 L89.950898,113.640015 C86.4569223,115.74729 82.4820496,116.85791 78.4342736,116.85791 C74.3864976,116.85791 70.4116249,115.74729 66.9176492,113.640015 L12.607673,80.7600098 C12.313102,80.5846471 12.0684349,80.3324865 11.8982132,80.0288391 C11.7279915,79.7251918 11.6382009,79.3807243 11.637852,79.0299988 L11.637852,69.9299927 C11.636157,69.7526418 11.6802261,69.5780353 11.7655613,69.4240417 C11.8508965,69.2700482 11.9744041,69.1422228 12.1234433,69.0536804 C12.2724824,68.965138 12.4416776,68.9190543 12.6136811,68.920166 C12.7856847,68.9212777 12.9543106,68.9695356 13.1022616,69.0599976 L66.9661284,101.610016 C70.4601041,103.717291 74.4349768,104.827911 78.4827528,104.827911 C82.5305288,104.827911 86.5054015,103.717291 89.9993772,101.610016 L153.280198,63.5500183 C154.22878,63.0005652 155.006101,62.1840632 155.521311,61.1959534 C156.03652,60.2078435 156.268334,59.0889285 156.189661,57.9700012 L156.189661,46.8500061 C156.116398,47.819563 155.812642,48.7555794 155.305196,49.5753174 C154.79775,50.3950554 154.102242,51.07328 153.280198,51.5500183 L89.950898,89.6400146 C86.4569223,91.7472897 82.4820496,92.8579102 78.4342736,92.8579102 C74.3864976,92.8579102 70.4116249,91.7472897 66.9176492,89.6400146 L2.90946301,50.8800049 C2.06484239,50.3854568 1.35519858,49.6787275 0.846521616,48.825531 C0.33784465,47.9723345 0.0466508093,47.0003685 0,46 L0,82.3200073 C0.0946766894,83.2496929 0.401514253,84.1430472 0.89541518,84.9269409 C1.38931611,85.7108346 2.05623268,86.3629929 2.84156844,86.8300171 L66.8497546,125.590027 C70.3437304,127.697302 74.318603,128.807922 78.366379,128.807922 C82.414155,128.807922 86.3890277,127.697302 89.8830034,125.590027 L153.280198,87.5500183 C154.22878,87.0005652 155.006101,86.1840632 155.521311,85.1959534 C156.03652,84.2078435 156.268334,83.0889285 156.189661,81.9700012 L156.121766,70.8500061 Z",
    id: "path-18"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.0%",
    y: "-1.8%",
    width: "101.9%",
    height: "103.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-19"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.0391058%",
    y1: "48.804526%",
    x2: "93.8547498%",
    y2: "50.796985%",
    id: "linearGradient-20"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25EBA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F5EBF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M153.276317,51.7045593 L89.9470046,89.7945557 C86.4497267,91.8918629 82.4761375,92.9967041 78.4303793,92.9967041 C74.3846211,92.9967041 70.4110318,91.8918629 66.913754,89.7945557 L2.90556357,51.0345459 C2.02203637,50.5158634 1.28820573,49.7641991 0.779344555,48.8566284 C0.270483379,47.9490577 0.00489784473,46.9182492 0.009765625,45.8699341 C0.0147685055,44.8216189 0.290049269,43.7935167 0.80743172,42.8910828 C1.32481417,41.9886488 2.06567354,41.2443715 2.95404278,40.7345581 L66.3221477,3.134552 C69.7896593,1.08076668 73.7186807,0 77.7175454,0 C81.7164101,0 85.6454315,1.08076668 89.1129431,3.134552 L153.21813,41.404541 C154.106991,41.9134609 154.848543,42.6570083 155.366783,43.5589294 C155.885024,44.4608505 156.161271,45.488699 156.167282,46.5370178 C156.173116,47.5853367 155.908538,48.6163898 155.400523,49.5244751 C154.892508,50.4325604 154.159368,51.1849964 153.276317,51.7045593 Z",
    id: "path-21"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.0%",
    y: "-1.6%",
    width: "101.9%",
    height: "103.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-22"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.84848571%",
    y1: "49.4736888%",
    x2: "96.9696952%",
    y2: "49.4736878%",
    id: "linearGradient-23"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#918ABD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878ED1",
    offset: "56.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF81C4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M155.375095,43.5999985 C154.890185,42.6999985 154.114331,42 153.241492,41.4000015 L89.1363219,3.0999999 C85.6449662,1.0999999 81.6686967,0 77.6924305,0 C73.7161643,0 69.8368828,1.0999999 66.3455271,3.0999999 L2.91922878,40.7000008 C2.04638986,41.2000008 1.27053301,42 0.785622479,42.9000015 C0.300711953,43.8000015 0.009765625,44.8000015 0.009765625,45.9000015 C0.009765625,46.9000015 0.300711953,48 0.785622479,48.9000015 C1.27053301,49.8000015 2.04638986,50.5 2.91922878,51 L66.9274183,89.8000031 C70.418774,91.900003 74.3950421,93 78.4682903,93 C82.5415386,93 86.5178066,91.900003 90.0091623,89.8000031 L153.241492,51.7000008 C154.114331,51.2000008 154.890185,50.4 155.375095,49.5 C155.860006,48.6 156.150955,47.6 156.150955,46.5 C156.150955,45.5 155.860006,44.5 155.375095,43.5999985 Z M25.9039885,49.0999985 C25.3220958,50 24.3522737,50.8 23.1884884,51.5 L14.4600989,46.2999992 L23.1884884,41.0999985 C24.3522737,41.7999985 25.2251138,42.6 25.9039885,43.5 C26.4858811,44.4 26.8738095,45.2999992 26.8738095,46.2999992 C26.8738095,47.2999992 26.5828632,48.1999985 25.9039885,49.0999985 Z M37.0569306,56.2999992 C36.7659843,56.5 36.3780536,56.6999992 35.9901252,56.7999992 C35.6021968,56.8999992 35.1172885,57 34.632378,57 C34.1474674,57 33.6625554,57 33.274627,56.9000015 C32.7897165,56.8000015 32.4017888,56.7 32.0138604,56.5 L31.8198954,56.4000015 C31.1410207,56 30.8500759,55.5 30.7530938,55 C30.7530938,54.5 31.0440378,53.9 31.6259305,53.5 C34.3414294,51.5 35.796164,48.8999991 35.796164,46.2999992 C35.796164,43.6999993 34.3414294,41.0999985 31.6259305,39.0999985 C31.0440378,38.6999985 30.7530938,38.1 30.7530938,37.5 C30.8500759,36.9 31.2380035,36.3999985 32.0138604,36.0999985 C32.6927351,35.6999985 33.6625569,35.5999985 34.632378,35.5999985 C35.602199,35.5999985 36.4750379,35.8999992 37.0569306,36.2999992 C40.8392328,39.0999992 42.9728375,42.6000009 42.9728375,46.2000008 C42.9728375,49.9000008 40.8392328,53.5 37.0569306,56.2999992 Z M49.0827094,63.4000015 C48.7917631,63.6000015 48.4038362,63.8000015 48.0159078,63.9000015 C47.6279793,64 47.1430673,64.0999985 46.6581568,64.0999985 C46.1732463,64.0999985 45.688338,64.1 45.3004096,64 C44.815499,63.9 44.4275714,63.7999985 44.0396429,63.5999985 L43.845678,63.5 C43.1668032,63.1 42.8758547,62.5999985 42.7788726,62.0999985 C42.7788726,61.5999985 43.0698204,61 43.651713,60.5999985 C54.8046551,52.7999983 54.8046551,39.9000001 43.651713,32 C43.0698204,31.6 42.7788726,31 42.7788726,30.3999996 C42.8758547,29.7999996 43.2637861,29.3 44.0396429,29 C44.7185176,28.6 45.6883358,28.5 46.6581568,28.5 C47.6279779,28.5 48.5008168,28.8000008 49.0827094,29.2000008 C62.4662402,38.7000008 62.4662402,54 49.0827094,63.4000015 Z",
    id: "path-24"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.0%",
    y: "-1.6%",
    width: "101.9%",
    height: "103.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-25"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "22.6714859%",
    y1: "6.28571108%",
    x2: "77.3282818%",
    y2: "14.8571404%",
    id: "linearGradient-26"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "14.0625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8786C9",
    offset: "53.6458313%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5771B8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.84848571%",
    y1: "49.4736888%",
    x2: "96.9696952%",
    y2: "49.4736878%",
    id: "linearGradient-27"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#918ABD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878ED1",
    offset: "56.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF81C4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M110.898766,76.6000061 L81.7556549,59.0100098 C81.6086892,58.9221046 81.4866874,58.7959427 81.4018868,58.6441345 C81.3170862,58.4923263 81.2724609,58.3202091 81.2724609,58.1450195 C81.2724609,57.96983 81.3170862,57.7977127 81.4018868,57.6459045 C81.4866874,57.4940963 81.6086892,57.3679345 81.7556549,57.2800293 L103.722096,43.9500122 C104.016959,43.7744755 104.351439,43.6820679 104.691917,43.6820679 C105.032395,43.6820679 105.366875,43.7744755 105.661738,43.9500122 L135.154,61.8900146 C135.447154,62.0645252 135.690926,62.3151096 135.861063,62.6168518 C136.0312,62.918594 136.121778,63.2609884 136.123821,63.6100159 L136.123821,101.610016 C136.123123,102.311467 135.943542,103.000402 135.603099,103.607697 C135.262655,104.214991 134.773321,104.719282 134.184179,105.070007 L113.817937,117.470032 C113.220211,117.834244 112.538639,118.026367 111.844347,118.026367 C111.150056,118.026367 110.468484,117.834244 109.870758,117.470032 L107.126177,115.76001 L107.126177,115.690033 L108.910645,116.77002 C109.205361,116.94547 109.539653,117.037874 109.879963,117.037964 C110.220272,117.038054 110.554624,116.945832 110.849428,116.770538 C111.144233,116.595244 111.389128,116.34306 111.55951,116.039307 C111.729891,115.735554 111.819759,115.390908 111.820108,115.040009 L111.820108,78.3200073 C111.82307,77.9757941 111.739827,77.6366172 111.578422,77.3352966 C111.417018,77.033976 111.182905,76.7807116 110.898766,76.6000061 Z",
    id: "path-28"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-2.7%",
    y: "-2.0%",
    width: "105.5%",
    height: "104.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-29"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1.05104327e-07%",
    y1: "29.7767085%",
    x2: "99.999575%",
    y2: "33.7420598%",
    id: "linearGradient-30"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "14.0625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8786C9",
    offset: "53.6458313%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5771B8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.69396859,1.63287952 C6.28592701,-0.544282447 12.1096441,-0.544283161 15.7016021,1.63287857 C17.4622006,2.7000146 18.3598408,4.09213664 18.3945235,5.49066086 L18.3954533,7.23777986 L18.3821907,7.2372507 C18.2650196,8.5623565 17.37145,9.86694743 15.7014824,10.8791501 C12.109524,13.0563121 6.28581125,13.0563119 2.69385328,10.8791501 C1.02388587,9.86694754 0.130316912,8.56235687 0.0131465908,7.2372513 L-0.000115549774,7.23777986 L-0.000115549774,5.49072695 C0.0357288843,4.09213753 0.933369832,2.70001567 2.69396859,1.63287952 Z",
    id: "path-31"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-8.2%",
    y: "-12.0%",
    width: "116.3%",
    height: "124.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-32"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.84848571%",
    y1: "49.4736888%",
    x2: "96.9696952%",
    y2: "49.4736878%",
    id: "linearGradient-33"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#918ABD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878ED1",
    offset: "56.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF81C4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.69396883,9.51707193 C6.2859268,11.6942337 12.1096395,11.6942339 15.7015979,9.51707193 C19.2935564,7.33990996 19.2935596,3.81003267 15.7016016,1.63287094 C12.1096437,-0.54429079 6.28592703,-0.544290076 2.6939686,1.63287189 C-0.89798984,3.81003386 -0.897989147,7.3399102 2.69396883,9.51707193 Z",
    id: "path-34"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-8.2%",
    y: "-13.5%",
    width: "116.3%",
    height: "126.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-35"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1.05104327e-07%",
    y1: "36.0999498%",
    x2: "99.999575%",
    y2: "38.8254499%",
    id: "linearGradient-36"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "14.0625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8786C9",
    offset: "53.6458313%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5771B8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.0391058%",
    y1: "48.9847054%",
    x2: "93.8547498%",
    y2: "50.676865%",
    id: "linearGradient-37"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25EBA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F5EBF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.89208237,8.52743519 C6.82236408,10.135635 11.5732883,10.1356352 14.5035703,8.52743519 C17.4338522,6.91923518 17.4338546,4.31182763 14.5035729,2.70362784 C11.5732912,1.09542805 6.82236408,1.0954285 3.89208215,2.70362851 C0.961800215,4.31182853 0.961800662,6.9192354 3.89208237,8.52743519 Z",
    id: "path-38"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-10.0%",
    y: "-18.2%",
    width: "120.0%",
    height: "136.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-39"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration-symbols",
    transform: "translate(-2480.000000, -1297.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration-/-Wallet",
    transform: "translate(2480.000000, 1297.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-122",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.897667, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.8655382,10.0009584 C81.5838986,9.96777717 85.3199055,10.7961469 88.157177,12.4860678 L100.111208,19.6052544 C105.232062,18.0660856 110.938339,20.1105607 113.830205,24.8990948 L116.546,29.395 L151.976993,50.498097 C152.570511,50.8516052 153.100732,51.2285374 153.567657,51.6238975 C154.302268,52.1161679 154.918188,52.7782151 155.366783,53.5589294 C155.885024,54.4608505 156.161271,55.488699 156.167282,56.5370178 C156.169585,56.9508818 156.129743,57.3620548 156.049414,57.7640329 C156.119605,57.4642584 156.166325,57.1588394 156.189661,56.8500175 L156.189661,67.9700127 C156.268334,69.0889399 156.03652,70.207855 155.521311,71.1959648 C155.006101,72.1840746 154.22878,73.0005766 153.280198,73.5500298 L151.584,74.57 L153.222297,75.5499268 C154.099677,76.0624179 154.830395,76.804508 155.340702,77.7012939 C155.85101,78.5980799 156.122839,79.6178213 156.12883,80.6575623 L156.122619,80.9688775 L156.189661,91.9700127 C156.268334,93.0889399 156.03652,94.207855 155.521311,95.1959648 C155.006101,96.1840746 154.22878,97.0005766 153.280198,97.5500298 L136.133,107.839 L136.133522,111.650097 C136.132844,112.263867 135.995267,112.868054 135.732813,113.41635 L135.612722,113.647778 C135.272279,114.255072 134.782944,114.759363 134.193802,115.110088 L114.351243,127.220104 C114.134687,127.34863 113.909645,127.459221 113.678244,127.551315 L113.817937,127.470093 C113.220211,127.834305 112.538639,128.026428 111.844347,128.026428 C111.150056,128.026428 110.468484,127.834305 109.870758,127.470093 L107.126177,125.760071 L107.126177,125.690094 L107.164,125.713 L107.164,125.221 L89.8830034,135.590038 C86.53461,137.60951 82.7445595,138.713652 78.8719418,138.802158 L78.366379,138.807934 C75.9864367,138.807934 73.631697,138.423992 71.3850885,137.679272 C66.5820181,138.614741 61.493727,136.533419 58.8168814,132.100931 L57.507,129.933 L2.84156844,96.8300285 C2.14349221,96.4148959 1.53898176,95.8534845 1.06638192,95.1832979 L0.89541518,94.9269524 C0.401514253,94.1430587 0.0946766894,93.2497043 0,92.3200188 L0,56.0000114 C0.00366653518,56.0786357 0.00884366743,56.1570846 0.0155182591,56.2353141 L0.0182469513,56.2062914 L0.0163917127,56.1837977 C0.0114966021,56.079422 0.00927884697,55.9747656 0.009765625,55.8699341 C0.0147685055,54.8216189 0.290049269,53.7935167 0.80743172,52.8910828 C1.32481417,51.9886488 2.06567354,51.2443715 2.95404278,50.7345581 L66.3221477,13.134552 C69.7896593,11.0807667 73.7186807,10 77.7175454,10 Z",
    id: "Union",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero",
    opacity: 0.699999988,
    filter: "url(#filter-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.280484,75.7999878 L89.9899434,113.899994 C86.493651,116.000281 82.5196784,117.106842 78.4733181,117.106842 C74.4269578,117.106842 70.4529852,116.000281 66.9566928,113.899994 L2.94850271,75.1399841 C2.06497552,74.6213016 1.33114488,73.8696374 0.822283705,72.9620667 C0.313422531,72.0544959 0.0478666021,71.0236875 0.052734375,69.9753723 C0.0577372628,68.9270571 0.332988421,67.8989549 0.85037087,66.996521 C1.36775332,66.0940871 2.10864228,65.3498098 2.99701152,64.8399963 L66.3651162,27.2399902 C69.834207,25.1910434 73.7626138,24.1130981 77.7605138,24.1130981 C81.7584139,24.1130981 85.6868206,25.1910434 89.1559115,27.2399902 L153.222297,65.5499878 C154.099677,66.0624789 154.830395,66.804569 155.340702,67.701355 C155.85101,68.598141 156.122839,69.6178824 156.12883,70.6576233 C156.134644,71.6973642 155.874415,72.7203149 155.374324,73.6231995 C154.874233,74.526084 154.151986,75.2769408 153.280484,75.7999878 L153.280484,75.7999878 Z",
    id: "Vector",
    fill: "url(#linearGradient-5)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-33",
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-6)",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-8)",
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-32",
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-6)",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-10)",
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-31",
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-6)",
    xlinkHref: "#path-11"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-12)",
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-30",
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-6)",
    xlinkHref: "#path-13"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-14)",
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-29",
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-6)",
    xlinkHref: "#path-15"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-16)",
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-17)",
    xlinkHref: "#path-18"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-19)",
    xlinkHref: "#path-18"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-20)",
    xlinkHref: "#path-21"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-22)",
    xlinkHref: "#path-21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-23)",
    xlinkHref: "#path-24"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-25)",
    xlinkHref: "#path-24"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M135.163639,61.9000244 L105.671377,43.960022 C105.376515,43.7844853 105.042035,43.6920776 104.701556,43.6920776 C104.361078,43.6920776 104.026598,43.7844853 103.731735,43.960022 L81.7652953,57.2900085 C81.5988593,57.3893321 81.4647998,57.5374571 81.3801845,57.7155151 C81.2955691,57.8935731 81.2641979,58.0935253 81.2900629,58.2900085 L81.2900629,63.3700256 C81.2641979,63.5665089 81.2955691,63.7664916 81.3801845,63.9445496 C81.4647998,64.1226076 81.5988593,64.2707021 81.7652953,64.3700256 L107.16491,79.7000122 L107.16491,115.76001 L109.414872,117.160004 C110.15709,117.624864 111.006769,117.875676 111.875118,117.886581 C112.743468,117.896785 113.598619,117.666723 114.351258,117.220032 L134.193818,105.110016 C134.78296,104.759291 135.272294,104.255 135.612737,103.647705 C135.953181,103.04041 136.132762,102.351475 136.133537,101.650024 L136.133537,63.6500244 C136.136534,63.2959135 136.048375,62.9472982 135.877982,62.6398315 C135.707589,62.3323649 135.461072,62.0770728 135.163639,61.9000244 L135.163639,61.9000244 Z",
    id: "Vector",
    fill: "url(#linearGradient-26)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-27)",
    xlinkHref: "#path-28"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-29)",
    xlinkHref: "#path-28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    fillRule: "evenodd",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(105.220128, 58.256007) scale(-1, 1) translate(-105.220128, -58.256007) translate(96.022287, 52.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-30)",
    xlinkHref: "#path-31"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-32)",
    xlinkHref: "#path-31"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-33)",
    xlinkHref: "#path-34"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-35)",
    xlinkHref: "#path-34"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.72086494,8.70390103 C6.745672,10.4095676 11.6498521,10.4095679 14.6746594,8.70390103 C17.6994667,6.99823418 17.6994692,4.23280165 14.6746621,2.52713504 C11.6498551,0.821468425 6.745672,0.821468901 3.72086471,2.52713575 C0.696057426,4.2328026 0.696057888,6.99823442 3.72086494,8.70390103 Z",
    id: "Vector",
    fill: "url(#linearGradient-36)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-37)",
    xlinkHref: "#path-38"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-39)",
    xlinkHref: "#path-38"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletColor);
export default __webpack_public_path__ + "static/media/WalletColor.b3c3bbcba0e96d85b8bd76eebdeccc51.svg";
export { ForwardRef as ReactComponent };